<template>
  <div class="mainCont mainContactus clear on">
    <div class="mainBody clear">
      <form id="form">
        <input
          class="form-input"
          type="text"
          v-model="postData.createUser"
          placeholder="您的名字："
        />
        <input
          class="form-input"
          type="text"
          v-model="postData.onlinePhone"
          placeholder="您的手机号码："
        />
        <textarea
          class="form-textarea"
          rows="10"
          cols="30"
          v-model="postData.onlineContent"
          placeholder="您的需求："
        >
        </textarea>
        <div class="form-submit" @click="submitCon()">提交</div>
      </form>
      <div class="box-info">
        <div class="box-item">
          <img src="../../assets/images/contactus/ico.png" class="box-icon" />
          <div class="box_tit">地　　址：</div>
          <span> {{ Enterprise.enterpriseAddress }} </span>
        </div>
        <div class="box-item">
          <img src="../../assets/images/contactus/ico2.png" class="box-icon" />
          <div class="box_tit">电　　话：</div>
          <span> {{ Enterprise.enterprisePhone }} </span>
        </div>
        <div class="box-item">
          <img src="../../assets/images/contactus/ico3.png" class="box-icon" />
          <div class="box_tit">传　　真：</div>
          <span> {{ Enterprise.visionContent }}</span>
        </div>
        <div class="box-item">
          <img src="../../assets/images/contactus/ico4.png" class="box-icon" />
          <div class="box_tit">网　　址：</div>
          <span> {{ Enterprise.enterpriseWebsite }} </span>
        </div>
        <div class="box-item">
          <img src="../../assets/images/contactus/ico5.png" class="box-icon" />
          <div class="box_tit">Email：</div>
          <span> {{ Enterprise.enterpriseEmail }} </span>
        </div>
      </div>
    </div>
    <img class="mainBody m-cont-right" id="container" src="../../assets/images/contactus/ditu.png" alt="" @click="openMap">
    <!-- <div class="mainBody m-cont-right" id="container">
      <el-amap
        vid="amapDemo"
        style="height: 550px"
        :center="center"
        :amap-manager="amapManager"
        :zoom="zoom"
        class="amap-demo"
      >
        <el-amap-marker :position="center"></el-amap-marker>

        <el-amap-info-window
          :position="center"
          :offset="[0, 0]"
          auto-move
          is-custom
        >
          <div class="info-window-content">
            <b>{{ Enterprise.enterpriseName }}</b>
            <p>电话：{{ Enterprise.enterprisePhone }}</p>
            <p>地址：{{ Enterprise.enterpriseAddress }}</p>
          </div>
        </el-amap-info-window>
      </el-amap>
    </div> -->
    <div class="model" v-show="isShow" @click="isShow = false"></div>
    <div class="model_con" v-show="isShow">
      <h3 class="title">请输入验证码</h3>
      <div class="line">
        <input placeholder="请输入验证码" v-model="postData.code" />
        <img :src="chaObj.img ? url + chaObj.img : ''" @click="chaImg" />
      </div>
      <el-button type="primary" class="mainBtn" @click="addLine">
        确定
      </el-button>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
// import VueAMap from "vue-amap";
// import MapLoader from "@/plugins/aMap.js";

// let amapManager = new VueAMap.AMapManager();
export default {
  data() {
    return {
      url: "data:image/gif;base64,",
      chaObj: "",
      postData: {
        createUser: "",
        onlinePhone: "",
        onlineContent: "",
        code: "",
        uuid: "",
      },
      isShow: false,
      center: [111.376213, 23.480257],
      zoom: 16, //缩放级别
      // amapManager,
      // Enterprise: {
      //   enterpriseName: "广西梧州市万秀区梧松路1号（扶典） ",
      //   enterprisePhone:
      //     "0774-2063353 3811505 2063293（经营部），3811522（办公室）",
      //   enterpriseAddress: "广西梧州市万秀区梧松路1号（扶典） ",
      //   enterpriseEmail:
      //     "（经营部):hpchemical@vip.163.com   （办公室) : wzhphg@163.com",
      //   visionContent: "0774-3811538",
      //   enterpriseWebsite: "www.wzhphg.com ",
      // },
      Enterprise:{}
    };
  },
  mounted() {
    // this.submitCon()
    // loadingInstance.close();
    // Loading.service()
    // this.chaImg();
    this.getEnterprisePage();
  },
  methods: {
    openMap() {
      window.open(
        "https://map.baidu.com/poi/%E6%A2%A7%E5%B7%9E%E9%BB%84%E5%9F%94%E5%8C%96%E5%B7%A5%E8%8D%AF%E4%B8%9A%E6%9C%89%E9%99%90%E5%85%AC%E5%8F%B8/@12398770.066596774,2674335.411270542,15.98z?uid=71fada3d43c81e8e8bf15d6a&info_merge=1&isBizPoi=false&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl"
      );
    },
    async getEnterprisePage() {
      let res = await this.$request.getEnterprisePage();
      let dataList = [];
      if (res.code === 200) {
        dataList = await res.rows.filter((item) => {
          return item.enterpriseName == "梧州黄埔化工药业有限公司";
          // console.log(resItem)
          // console.log(dataItem);
        });
      }
      this.Enterprise = dataList[0];
      // console.log(dataList[0]);
    },
    async chaImg() {
      let imgobj = await this.$request.getChaimg();
      this.chaObj = imgobj;
      this.postData.uuid = imgobj.uuid;
    },
    addLine() {
      if (!this.postData.code) {
        this.$alert("请输入验证码", "温馨提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let loadingInstance = Loading.service();
      //联系方式
      this.$request.postaddInfo(this.postData).then((res) => {
        loadingInstance.close();
        this.isShow = false;
        if (res.code == "200") {
          // this.$message.warning("您的需求，已提交成功");
          this.$alert("您的需求，已提交成功", "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              this.postData = {
                createUser: "",
                onlinePhone: "",
                onlineContent: "",
                code: "",
                uuid: "",
              };
            },
          });
          // console.log("提交成功")
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    checkMobile(s) {
      var regu = /^1[3456789]\d{9}$/;
      var re = new RegExp(regu);
      if (re.test(s)) {
        return true;
      } else {
        return false;
      }
    },
    submitCon() {
      if (!this.postData.createUser) {
        this.$alert("请输入您的名字", "温馨提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      if (!this.postData.onlinePhone) {
        this.$alert("请输入您的手机号码", "温馨提示", {
          confirmButtonText: "确定",
        });
        return;
      } else {
        if (
          !this.checkMobile(this.postData.onlinePhone.replace(/(^\s*)/g, ""))
        ) {
          this.$alert("请输入正确的手机号码", "温馨提示", {
            confirmButtonText: "确定",
          });
          return false;
        }
      }
      if (!this.postData.onlineContent) {
        this.$alert("请输入您的需求", "温馨提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      // 更新验证码
      this.chaImg();

      this.isShow = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.mainContactus {
  width: 100%;
  padding-top: 3.13vw;
  background: url(../../assets/images/contactus/bg.png) no-repeat;
  background-size: 100% 100%;
  .amap-demo {
    position: relative;
    z-index: 99;
    .info-window-content {
      width: 31.25vw;
      b {
        font-size: 0.83vw;
        display: inline-block;
        padding: 0.52vw 0;
      }
      p {
        font-size: 0.83vw;
      }
    }
  }

  .box-info {
    float: left;
    width: 35.68vw;
    background-color: #ffffff;
    // height: 13.33vw;
    padding: 1.56vw 2.08vw;
    position: relative;
    box-sizing: border-box;
    margin-left: 3.91vw;
    &:before {
      content: "";
      display: block;
      position: absolute;
      width: 0.89vw;
      height: 1.46vw;
      top: 0;
      left: 0;
      background-color: #83bb26;
    }
    .box-item {
      margin-bottom: 1.04vw;
      color: #333333;
      font-size: 0.83vw;
      // height: 1.15vw;
      line-height: 1.15vw;

      .box-icon {
        width: 0.94vw;
        margin-right: 1.04vw;
        display: inline-block;
      }

      .box_tit {
        display: inline-block;
      }
    }
  }
  #form {
    width: 33.33vw;
    position: relative;
    float: left;
    .form-input,
    .form-textarea {
      outline: none;
    }

    .form-input {
      border: none;
      display: inline-block;
      width: 16.15vw;
      padding: 0.52vw;
      box-sizing: border-box;
      border: solid 0.1vw #87c31e;
      font-size: 0.83vw;
      &:nth-child(1) {
        margin-right: 1vw;
      }
    }

    .form-textarea {
      border: none;
      display: block;
      width: 33.33vw;
      height: 6.98vw;
      font-size: 0.83vw;
      margin-top: 1.04vw;
      border: solid 0.1vw #87c31e;
      padding: 0.52vw;
      box-sizing: border-box;
      font-family: Noto Sans SC, arial, helvetica, clean, sans-serif;
    }

    .form-submit {
      border: none;
      width: 33.33vw;
      height: 2.08vw;
      line-height: 2.08vw;
      font-size: 0.83vw;
      color: #ffffff;
      text-align: center;
      margin-top: 1.04vw;
      background-color: #87c31e;
      cursor: pointer;
      box-sizing: border-box;
    }
  }

  .model {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.5);
  }

  .model_con {
    position: fixed;
    z-index: 1000;
    top: 50%;
    left: 50%;
    width: 20.8333vw;
    border-radius: 0.3125vw;
    padding: 1.3021vw 1.3021vw 1.3021vw 1.3021vw;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    background: #ffffff;

    .title {
      text-align: center;
      color: #707070;
      font-size: 0.975vw;
      font-weight: 600;
      margin-bottom: 1.5625vw;
    }

    input {
      width: 10.4167vw;
      height: 1.9792vw;
      border-radius: 0.2604vw;
      border: 0.0521vw solid #dcdfe6;
      margin-right: 1.0417vw;
      outline: none;
      padding-left: 1.0417vw;
      font-size: 0.9375vw;
      box-sizing: border-box;
    }

    img {
      width: 5.9896vw;
      display: inline-block;
      vertical-align: middle;
      cursor: pointer;
    }
  }

  .mainBtn {
    width: 100%;
    margin-top: 1.5625vw;
  }
  .m-cont-right {
    display: block;
    cursor: pointer;
    margin-top: 2.08vw;
    margin-bottom: 3.13vw;
  }
}
@media (min-width: 1920px) {
  .mainContactus {
    width: 100%;
    padding-top: 60px;
    background: url(../../assets/images/contactus/bg.png) no-repeat;
    background-size: 100% 100%;
    .amap-demo {
      position: relative;
      z-index: 99;
      .info-window-content {
        width: 520px;
        b {
          font-size: 0.83vw;
          display: inline-block;
          padding: 10px 0;
        }
        p {
          font-size: 0.83vw;
        }
      }
    }

    .box-info {
      float: left;
      width: 685px;
      background-color: #ffffff;
      // height: 256px;
      padding: 30px 40px;
      position: relative;
      box-sizing: border-box;
      margin-left: 75px;
      &:before {
        content: "";
        display: block;
        position: absolute;
        width: 17px;
        height: 28px;
        top: 0;
        left: 0;
        background-color: #83bb26;
      }
      .box-item {
        margin-bottom: 20px;
        color: #333333;
        font-size: 16px;
        // height: 22px;
        line-height: 22px;
        display: flex;
        align-items: center;
        .box-icon {
          width: 18px;
          margin-right: 20px;
          display: inline-block;
        }

        .box_tit {
          display: inline-block;
        }
        span {
        }
      }
    }
    #form {
      width: 640px;
      position: relative;
      float: left;
      .form-input,
      .form-textarea {
        outline: none;
      }

      .form-input {
        border: none;
        display: inline-block;
        width: 310px;
        padding: 10px;
        box-sizing: border-box;
        border: solid 2px #87c31e;
        font-size: 16px;
        &:nth-child(1) {
          margin-right: 20px;
        }
      }

      .form-textarea {
        border: none;
        display: block;
        width: 640px;
        height: 134px;
        font-size: 16px;
        margin-top: 20px;
        border: solid 2px #87c31e;
        padding: 10px;
        box-sizing: border-box;
        font-family: Noto Sans SC, arial, helvetica, clean, sans-serif;
      }

      .form-submit {
        border: none;
        width: 640px;
        height: 40px;
        line-height: 40px;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        margin-top: 20px;
        background-color: #87c31e;
        cursor: pointer;
        box-sizing: border-box;
      }
    }

    .model {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1000;
      background: rgba(0, 0, 0, 0.5);
    }

    .model_con {
      position: fixed;
      z-index: 1000;
      top: 50%;
      left: 50%;
      width: 20.8333vw;
      border-radius: 0.3125vw;
      padding: 1.3021vw 1.3021vw 1.3021vw 1.3021vw;
      transform: translate(-50%, -50%);
      box-sizing: border-box;
      background: #ffffff;

      .title {
        text-align: center;
        color: #707070;
        font-size: 0.975vw;
        font-weight: 600;
        margin-bottom: 1.5625vw;
      }

      input {
        width: 10.4167vw;
        height: 1.9792vw;
        border-radius: 0.2604vw;
        border: 0.0521vw solid #dcdfe6;
        margin-right: 1.0417vw;
        outline: none;
        padding-left: 1.0417vw;
        font-size: 0.9375vw;
        box-sizing: border-box;
      }

      img {
        width: 5.9896vw;
        display: inline-block;
        vertical-align: middle;
        cursor: pointer;
      }
    }

    .mainBtn {
      width: 100%;
      margin-top: 1.5625vw;
    }
    .m-cont-right {
      display: block;
    cursor: pointer;
      margin-top: 40px;
      margin-bottom: 60px;
    }
  }
}
.el-button--primary {
  background: #f39800;
  border: none;
}

.el-button--primary:focus,
.el-button--primary:hover {
  background: #f39800;
  border: none;
}

.el-button--primary {
  background: #f39800;
  border: none;
}

.el-button--primary:focus,
.el-button--primary:hover {
  background: #f39800;
  border: none;
}
</style>
